import { useState } from "react";
import { Loader2 } from "lucide-react";

const F = "mt-1 w-full h-11 rounded-md border border-[#E4E0D8] bg-white px-2 text-[15px]";
const LABEL = "text-[12px] text-archival-secondary";
const TITLE = (s) => (s || "").replace(/_/g, " ").toLowerCase();

const newId = () => (crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

export const ExpenseForm = ({ meta, today, onSubmit, busy, error }) => {
  const [form, setForm] = useState({
    business_date: today, category: "", amount: "", payment_method: "CASH",
    description: "", payee_name: "", backdated_reason: "",
  });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    onSubmit({ ...form, client_request_id: newId() }, () => setForm({ ...form, amount: "", description: "", payee_name: "" }));
  };

  return (
    <form onSubmit={submit} data-testid="expense-form" className="rounded-lg border border-[#E4E0D8] bg-white p-3">
      <div className="grid grid-cols-2 gap-2">
        <label className={LABEL}>Date
          <input type="date" max={today} value={form.business_date} onChange={set("business_date")}
            data-testid="expense-date-input" className={F} required />
        </label>
        <label className={LABEL}>Amount
          <input inputMode="decimal" placeholder="0.00" value={form.amount} onChange={set("amount")}
            data-testid="expense-amount-input" className={`${F} tabular-nums`} required />
        </label>
        <label className={LABEL}>Category
          <select value={form.category} onChange={set("category")} data-testid="expense-category-select" className={`${F} capitalize`} required>
            <option value="">Select…</option>
            {(meta?.categories || []).map((c) => <option key={c} value={c}>{TITLE(c)}</option>)}
          </select>
        </label>
        <label className={LABEL}>Paid by
          <select value={form.payment_method} onChange={set("payment_method")} data-testid="expense-method-select" className={`${F} capitalize`}>
            {Object.keys(meta?.payment_methods || { CASH: "CASH" }).map((m) => <option key={m} value={m}>{TITLE(m)}</option>)}
          </select>
        </label>
        <label className={`${LABEL} col-span-2`}>Description
          <input value={form.description} onChange={set("description")} placeholder="what was this for?"
            data-testid="expense-description-input" className={F} />
        </label>
        <label className={`${LABEL} col-span-2`}>Payee <span className="text-archival-muted">(optional)</span>
          <input value={form.payee_name} onChange={set("payee_name")} data-testid="expense-payee-input" className={F} />
        </label>
        {form.business_date && form.business_date < today && (
          <label className={`${LABEL} col-span-2`}>Reason for backdating
            <input value={form.backdated_reason} onChange={set("backdated_reason")}
              data-testid="expense-backdated-reason-input" className={F} />
          </label>
        )}
      </div>
      {error && <p data-testid="expense-form-error" className="mt-2 rounded bg-red-50 px-2 py-1 text-[12px] text-red-800">{error}</p>}
      <button type="submit" disabled={busy} data-testid="expense-submit-btn"
        className="mt-3 inline-flex h-11 w-full items-center justify-center gap-2 rounded-md bg-archival-primary text-[15px] font-semibold text-white disabled:opacity-50">
        {busy && <Loader2 size={15} className="animate-spin" />} Record expense
      </button>
    </form>
  );
};

// CashCountForm was removed when physical cash-count ownership moved to Accounts: Accounts owns the
// observation, expected cash and variance. Bills captures cash EXPENSES only.
